import {
    GET_MARKET_INTELLIGENCE,
    GET_NEWS_PAIRS,
    GET_MARKET_NEWS,
    GET_METRICS,
    GET_FILINGS,
    GET_INSIDERS,
    GET_SENTIMENT_ANALYSIS,
    GET_USER_WATCHLIST,
    SET_MARKET_INTELLIGENCE_LOADING,
    GET_SENTINENT_ASSESSMENT
} from "../actions/types";

const initialState = {
    marketIntelligence: null,
    newsPairs: [], // List of ALL available pairs (referencing 'news_pairs' from API)
    userWatchlist: [], // List of user's selected pairs (referencing 'watch_list' from API)
    marketNews: [],
    metrics: null,
    filings: null,
    insiders: null,
    sentimentAnalysis: [],
    sentimentAssessment:null,
    loading: false
};

const marketIntelligenceReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_MARKET_INTELLIGENCE:
            return {
                ...state,
                marketIntelligence: payload,
                loading: false 
            };
        case GET_NEWS_PAIRS:
            return {
                ...state,
                newsPairs: payload
            };
        case GET_USER_WATCHLIST:
            return {
                ...state,
                userWatchlist: payload
            };
        case GET_MARKET_NEWS:
            return {
                ...state,
                marketNews: payload
            };
        case GET_METRICS:
            return {
                ...state,
                metrics: payload
            };
        case GET_FILINGS:
            return {
                ...state,
                filings: payload
            };
        case GET_INSIDERS:
            return {
                ...state,
                insiders: payload
            };
        case GET_SENTIMENT_ANALYSIS:
            return {
                ...state,
                sentimentAnalysis: payload
            };
        case GET_SENTINENT_ASSESSMENT:
            return {
                ...state,
                sentimentAssessment: payload
            };
        case SET_MARKET_INTELLIGENCE_LOADING:
            return {
                ...state,
                loading: payload
            };
        default:
            return state;
    }
};

export default marketIntelligenceReducer;
